var fowtr_module_general = (function (fowtr_module_general) {


    // HASH NAVIGATION / SCROLLTOP / SCROLLING
    $("#fowtr-wrapper").on('click','a', function(event) {
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        if(this.hash.indexOf('#')==0 && this.hash.indexOf(':')!=1 && this.hash.length>1){
          event.preventDefault();
          // Store hash
          var hash = this.hash;
          // Using jQuery's animate() method to add smooth page scroll
          // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          // $('html, body').animate({
          //   scrollTop: $(hash).offset().top
          // }, 800, function(){
          //   // Add hash (#) to URL when done scrolling (default click behavior)
          //   window.location.hash = hash;
          // };
          // });

          //allow for header
          // var offset = 56; // without secondary nav




          // var offset = 56+52; // with secondary nav

          // var sectionToGoTo = $(this);

          // if(sectionToGoTo.hasClass('with6pinned')){
          //   // offset = 218+52; // with secondary nav
          //   offset = (108 + 106); // without secondary nav
          // }

          // if($(window).width() < 768){
          //   offset = (56 + 98);
          // }
          
          // if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
          //   offset = 0;
          //   if(sectionToGoTo.hasClass('with6pinned')){
          //     offset = 106;
          //   }
          // }




          var sectionToGoTo = $(this);

          var offset = 56+52; // header plus secondary nav
          if($(window).width() < 768){
            offset = 56;//mobile
          }
          if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
            offset = 0;//fullscreen
          }
          //if in pinned section
          if(sectionToGoTo.hasClass('with6pinned')){
            offset += 101;
          }

          TweenMax.to($('html, body'),0.8,{scrollTop:$(hash).offset().top-offset,ease:Power2.easeInOut});
        }
      }
    });







    //when clicking link that goes external, keep the section in view
    $("#fowtr-wrapper").on('click','a[target="_blank"]', function(event) {
      if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
        // console.log('currentSectionInView',fowtr_module_analytics.currentSectionInView);
        // var id = fowtr_module_analytics.currentSectionInView;

        var id = fowtr_module_utilities.getArticleClosestToCenter();
        console.log('trying to keep section '+id+' in view after exit fullscreen');
        setTimeout(function(){
          var offset = 56+52; // with secondary nav
          var sectionToGoTo = $('#fowtr-article'+id);
          if(id>6){ // has pinned top section 6
            offset = (108 + 106); // without secondary nav
          }
          if($(window).width() < 768){
            offset = (56 + 98);
          }
          if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
            offset = 0;
            if(id>6){// has pinned top section 6
              offset = 106;
            }
          }
          var st = $(sectionToGoTo).offset().top-offset;
          // TweenMax.to($('html, body'),0.8,{scrollTop:st,ease:Power2.easeInOut});
          // window.scrollTo({top:st,behavior:'smooth'});
          console.log('scrolling back to '+id);
          window.scrollTo({top:st});
        },2000);

      }
    });








    fowtr_module_general.init = function(){
      // console.log('fowtr_module_general init');

      // JQUERY INVIEW
      $.each($('.animate__inview'),function(){
          this.style.WebkitAnimation = 'none';
          this.style.animation = 'none';
          if(!$(this).hasClass('inview_dont_hide')) this.style.opacity = 0;
      });
      $('.animate__inview').on('inview', {offsetTop:50}, function(event, visible) {
          if (visible) {
              $(this).addClass('animate__animated');
              this.style.visibility = 'visible';
              this.style.WebkitAnimation = '';
              this.style.animation = '';
              this.style.opacity = 1;
          } else {
              //reset when out of view so it retriggers
              // this.style.WebkitAnimation = 'none';
              // this.style.animation = 'none';
              // this.style.visibility = 'hidden';
          }
      });


      // MASONRY - 
      $('.masonry').masonry({
        // options
        itemSelector: '.masonry-item',
        transitionDuration: 0,
        percentPosition: true,
        
        // columnWidth: 200
      });



      // // DEBUG
      // // -----
      // // output article div id's each time enter viewport
      // $.each($('#fowtr-wrapper article > div'), function(index, val) {
      //    $(this).on('inview', function(event, visible) {
      //        // event.stopPropagation();
      //        if(!$(event.target).is(this)) return;
      //        if (visible) {
      //           var id = $(this).attr('id');
      //            console.log(''+id);
      //        } else {
      //         // hidden
      //        }
      //    });
      // });




      // 100vh fix for mobiles with bars etc
      // var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      // height = height * 0.01;
      // // var vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty('--vh', vh+'px');
      // resize event
      var resizeEvent = fowtr_module_utilities.debounce(function(){
        var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var vh = height * 0.01;
        // var vh = window.innerHeight * 0.01;
        // document.documentElement.style.setProperty('--fowtr100vh', vh+'px');
        $('#fowtr-wrapper').css('--fowtr100vh',vh+'px');
      },500);
      window.onresize = resizeEvent;
      resizeEvent();





      // var beforePrint = function() {
      //     console.log('Functionality to run before printing.');
      // };
      // var afterPrint = function() {
      //     console.log('Functionality to run after printing');
      // };

      // if (window.matchMedia) {
      //     var mediaQueryList = window.matchMedia('print');
      //     mediaQueryList.addListener(function(mql) {
      //         if (mql.matches) {
      //             beforePrint();
      //         } else {
      //             afterPrint();
      //         }
      //     });
      // }

      // window.onbeforeprint = beforePrint;
      // window.onafterprint = afterPrint;


      window.onbeforeprint = function() {
         console.log('This will be called before the user prints.');
      };
      window.onafterprint = function() {
         console.log('This will be called after the user prints');
      };











      // // PUT SECTION ID MARKERS ON ALL ARTICLES
      // // $.each($('#fowtr-chapter4 article > div'), function(index, val) {
      // $.each($('.fowtr-chapter > article > div[id^="fowtr-article"], .fowtr-chapter > article .scrollmagic-pin-spacer > div[id^="fowtr-article"]'), function(index, val) {
      //    var id = $(this).attr('id');
      //    if(id){
      //     id = id.replace('fowtr-article','');
      //     // console.log('article',id);
      //     var marker = $('<div class="section-identifiers" style="opacity:0.7;background:magenta;color:white;position: absolute;top: 50%;left: 0;transform: rotate(-90deg);transform-origin: top left;padding: 10px;">Section <strong>'+id+'</strong></div>');
      //     $('#fowtr-article'+id).append(marker);
      //    }
      // });





    }; // end init






    // fowtr_module_general.onResize = function(width,height){

    //    // 100vh fix for mobiles with bars etc
    //    var vh = window.innerHeight * 0.01;
    //    document.documentElement.style.setProperty('--vh', vh+'px');
     
    // }; // end init

    return fowtr_module_general;
}(fowtr_module_general || {}));
